import { roundUpToTwoDecimals } from '../round-up-to-two-decimals'
import formatAnyNumber from './format-any-number'

export default function outputCalculatedValue(value: number) {
    return formatAnyNumber(roundUpToTwoDecimals(value))
}
